var MediaQueryDispatch = require('./MediaQueryDispatch');
module.exports = new MediaQueryDispatch();



//////////////////
// WEBPACK FOOTER
// ./~/enquire.js/src/index.js
// module id = ./node_modules/enquire.js/src/index.js
// module chunks = 137591856104208 266772403791747